import { SelfService } from "@/models/selfService.model";
import { axiosInstance } from "./axiosInstance";

export const sendLeads = async (data: any): Promise<SelfService> => {
  try {
    const response = await axiosInstance.post<SelfService>(`/api/leads`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateLeadBalanceSolicitation = async (
  selfServiceId: string,
  balanceSolicitationId: string,
  leadDocument: string
): Promise<Response> => {
  const response = await axiosInstance.put(`/api/leads/balance-solicitation`, {
    selfServiceId,
    balanceSolicitationId,
    leadDocument,
  });
  return response.data;
};
